/* eslint-disable react/prop-types */
import React from 'react';

import { createStyles, TableCell, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const styles = (_theme: Theme) =>
  createStyles({
    tableHeaderCell: {
      overflow: 'hidden',
      display: 'block',
      textOverflow: 'ellipsis',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      marginRight: 5,
      whiteSpace: 'nowrap',
    },
  });

const useStyles = makeStyles(styles);

interface NkTableHeaderCellProps {
  children: React.ReactNodeArray | React.ReactNode;
}

export const NkTableHeaderCell = ({ children }: NkTableHeaderCellProps) => {
  const classes = useStyles();

  return (
    <TableCell>
      <span className={classes.tableHeaderCell}>{children}</span>
    </TableCell>
  );
};

export default NkTableHeaderCell;
